/* eslint-disable import/prefer-default-export */
export const isOpen = (state) => (state.sidebar.isOpen);
